import React from 'react';
import styled, { css } from 'styled-components';
import { Grid } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HeaderRow = styled(Grid)`
  background: #EFEFEF;
  height: 43px;
  position: sticky;
  top: 126px;
  z-index: 50;
  margin-top: 0;
  margin-bottom: 12px;
  user-select: none;
  cursor: pointer;
  padding-top: 0.475rem;
  
  & + div {
    border-top: none !important;
  }
  
  > div:first-of-type {
    font-size: 1.15rem;
    font-weight: 500;
    line-height: 1.5;
    margin-top: .475rem;

    span {
      letter-spacing: .01em;
    } 
  }
`;

const StyledArrowIcon = styled(({ isOpen, ...props }) => (
  <FontAwesomeIcon {...props} />
))`
  font-size: 1.2em;
  vertical-align: -0.15em;
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
  transition: transform 0.3s ease;
  ${(props) =>
    props.isOpen &&
    css`
      transform: rotate(90deg);
    `}
`;

const TimeBucketTimesheetContainer = styled.div`
    margin-top: 1rem;
`;

const CategoryName = styled.span`
  margin-right: 0.5rem;
`;

export {
  HeaderRow,
  StyledArrowIcon,
  TimeBucketTimesheetContainer,
  CategoryName
};
